import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import AdventCalender from '@/AdventCalender.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

const { ioappConfig } = window;
const backgroundImg = `${ioappConfig.themeUri}/assets/img/zens-calendar-background.jpg`;


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "advent-background",
    style: _normalizeStyle({ backgroundImage: `url(${backgroundImg})` })
  }, [
    _createVNode(AdventCalender)
  ], 4))
}
}

})